"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHLQATaskDetailsInCache = void 0;
const parseArgsFromStoreFieldName = (storeFieldName) => {
    if (!storeFieldName) {
        return undefined;
    }
    const openParenIndex = storeFieldName.indexOf('(');
    if (openParenIndex === -1) {
        return undefined;
    }
    const rawArgs = storeFieldName.slice(openParenIndex + 1, storeFieldName.lastIndexOf(')'));
    try {
        const parsed = JSON.parse(rawArgs);
        return parsed;
    }
    catch (_a) {
        return undefined;
    }
};
const isMatchingPriorityTasksField = (storeFieldName, variables) => {
    var _a, _b, _c, _d;
    if (!(storeFieldName === null || storeFieldName === void 0 ? void 0 : storeFieldName.startsWith('priorityTasks'))) {
        return false;
    }
    const effectiveArgs = parseArgsFromStoreFieldName(storeFieldName);
    if (!effectiveArgs || effectiveArgs.productTreeId !== variables.productTreeId) {
        return false;
    }
    const hasSameFirst = effectiveArgs.first === 1;
    if (!hasSameFirst) {
        return false;
    }
    const targetTaskKey = (_b = (_a = variables.filter) === null || _a === void 0 ? void 0 : _a.task) === null || _b === void 0 ? void 0 : _b.equals;
    if (!targetTaskKey) {
        return true;
    }
    const fieldTaskKey = (_d = (_c = effectiveArgs.filter) === null || _c === void 0 ? void 0 : _c.task) === null || _d === void 0 ? void 0 : _d.equals;
    return fieldTaskKey === targetTaskKey;
};
const patchPriorityTasksConnection = (priorityTasks, patch) => {
    var _a;
    if (!priorityTasks || typeof priorityTasks !== 'object') {
        return priorityTasks;
    }
    const currentPriorityTasks = priorityTasks;
    if (!Array.isArray(currentPriorityTasks.edges) || !((_a = currentPriorityTasks.edges[0]) === null || _a === void 0 ? void 0 : _a.node)) {
        return priorityTasks;
    }
    return Object.assign(Object.assign({}, currentPriorityTasks), { edges: currentPriorityTasks.edges.map((edge, index) => (index === 0
            ? Object.assign(Object.assign({}, edge), { node: Object.assign(Object.assign({}, edge.node), patch) }) : edge)) });
};
const updateCatalogPriorityTasksInCache = (cache, variables, patch) => {
    const catalogCacheId = cache.identify({ __typename: 'Catalog', id: variables.catalogId });
    if (!catalogCacheId) {
        return false;
    }
    let hasChanged = false;
    cache.modify({
        id: catalogCacheId,
        fields: {
            priorityTasks(existingPriorityTasks, details) {
                const { storeFieldName } = details;
                if (!isMatchingPriorityTasksField(storeFieldName, variables)) {
                    return existingPriorityTasks;
                }
                const next = patchPriorityTasksConnection(existingPriorityTasks, patch);
                if (next !== existingPriorityTasks) {
                    hasChanged = true;
                }
                return next;
            },
        },
    });
    return hasChanged;
};
const updateHLQATaskDetailsInCache = (cache, variables, patch) => updateCatalogPriorityTasksInCache(cache, variables, patch);
exports.updateHLQATaskDetailsInCache = updateHLQATaskDetailsInCache;
